export class Regional {

  public id: string;
  public descricao: string;

  constructor(id: string, descricao: string) {
    this.id = id;
    this.descricao = descricao;
  }
}